// FORGED Ed Systems — DEPLOY009 — v0.9.0 — App.tsx
// Last touched: 2026-05-21
//
// Router + auth wrapper. DEPLOY009 — replaced the placeholder landing copy
// with the production hero block (tagline + three-paragraph product brief +
// founder contact). All product routes unchanged.

import { Routes, Route, Link } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import RegisterPage from "./RegisterPage";
import SignInPage from "./SignInPage";
import DashboardPage from "./DashboardPage";
import IntakePage from "./IntakePage";
import ReportViewPage from "./ReportViewPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";

function LandingPage() {
  return (
    <main className="container">
      <header className="brand-header">
        <h1>forgedsight</h1>
        <p className="tagline">
          Strategic planning for welding programs — grounded in the codes your
          students will actually be tested against.
        </p>
      </header>

      <section className="hero">
        <p>
          <strong>FORGEDSIGHT</strong> is a free AI-powered strategic planning
          platform built for high school welding instructors. In about 10
          minutes, teachers enter their classroom setup, curriculum, cohort
          experience mix, and certification goals — then receive a customized
          operational strategy designed around real-world constraints like
          booth count, instructor experience, pacing, and code requirements.
          The plan exports as a branded PDF you can take to a CTE coordinator
          or administrator.
        </p>

        <p>
          Every recommendation is grounded in the welding standards and
          educational frameworks teachers actually teach to — AWS, NCCER, the
          American Welding Program, and TEKS — with cited clauses, modules,
          and standards behind each decision. When the system cannot
          confidently make a call, it says so instead of guessing.
        </p>

        <p>
          Instead of generating generic lesson plans, FORGEDSIGHT helps
          instructors stress-test their program before the term starts,
          identify operational bottlenecks, and surface the hidden gaps that
          quietly reduce certification pass rates. We work at the cohort level
          only — no student names, no per-student data, no FERPA exposure.
        </p>

        <div className="cta-row" style={{ marginTop: "2rem" }}>
          <Link to="/register" className="cta primary">
            Get started — it's free
          </Link>
          <Link to="/sign-in" className="cta secondary">
            Sign in
          </Link>
        </div>
      </section>

      <section className="footer-meta" style={{ marginTop: "3rem" }}>
        <p>
          <strong>Questions or feedback?</strong>
          <br />
          Richard Johnston, Matican Group —{" "}
          <a href="mailto:richard@maticangroup.com">richard@maticangroup.com</a>
        </p>
      </section>
    </main>
  );
}

function NotFoundPage() {
  return (
    <main className="container">
      <h1>Not found</h1>
      <p>That page doesn't exist.</p>
      <Link to="/">← Home</Link>
    </main>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/intake/new" element={<IntakePage />} />
        <Route path="/r/:reportId" element={<ReportViewPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
}
